import { Multiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function KiloNewton({ exponent }) {
  return <Unit unit={UnitBaseTypes.newton} prefix={Multiples.kilo} exponent={exponent} />;
}

export default KiloNewton;
